<template>
    <v-container v-if="isPrivate">
        <v-card tile outlined elevation="0" class="pa-16">
            <v-card-title for="qna-validate" class="justify-center">
                <label for="qna-validate" class="text-center">
                    Only writer of this content <br class="b-lg-none" />
                    can continue to read
                </label>
            </v-card-title>
            <v-card-actions class="justify-center pt-0">
                <v-btn outlined @click="$router.go(-1)" class="px-20">Back to the LIST</v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
    <v-container v-else-if="!authorized">
        <v-card tile outlined elevation="0" class="pa-4">
            <v-card-title for="qna-validate" class="justify-center">
                <label for="qna-validate" class="text-center">To read the posting <br class="b-lg-none" />Please input password</label>
            </v-card-title>
            <v-card-text class="text-center">
                <div class="input-inline-button">
                    <input v-model="filter.password" maxlength="6" type="password" id="qna-validate" class="input" />
                    <button @click="search" class="button button--primary">확인</button>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
    <component v-else :is="SkinComponent" v-bind="{ code, board, isUserWriter }" @remove="remove" />
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";

export default {
    props: {
        code: { type: String, default: null },
        skin: { type: String, default: null },
        _id: String,
    },
    data() {
        return {
            filter: {
                code: this.$props.code,
                password: null,
            },

            isPrivate: false,
            authorized: true,
            board: null,
        };
    },
    computed: {
        SkinComponent() {
            return () => import(`./skin/${this.$props.skin}/view.vue`);
        },
        isUserWriter() {
            return this.board?.writer?._id == this.$store.state.payload?._user;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        _id() {
            this.init();
        },
    },
    methods: {
        init() {
            if (this._id) this.search();
        },

        async search() {
            try {
                var { board, isPrivate, authorized } = await api.v1.boards.get({
                    _id: this.$props._id,
                    params: {
                        ...this.filter,
                        password: this.filter.password ? CryptoAES.encrypt(this.filter.password) : undefined,
                    },
                });

                this.board = board;
                this.isPrivate = isPrivate;
                this.authorized = authorized;
            } catch (error) {
                this.isPrivate = error.response.data?.isPrivate ?? false;
                this.authorized = error.response.data?.authorized ?? false;
            }
        },

        async remove() {
            const go = confirm("Do you really want to delete this posting?");
            if (!go) return;

            await api.v1.boards.delete(this.board);
            alert("The posting has been removed");
            this.$router.go(-1);
        },
    },
};
</script>
